import React from 'react';
interface ScoreRingProps {
  score: number;
  max?: number;
  label?: string;
  dynamicColor?: boolean;
  size?: 'sm' | 'md';
}
function getScoreColor(score: number) {
  if (score <= 3) return {
    ring: '#ef4444',
    ringLight: '#fee2e2',
    text: 'text-red-500'
  };
  if (score <= 6) return {
    ring: '#eab308',
    ringLight: '#fef9c3',
    text: 'text-yellow-500'
  };
  return {
    ring: '#22c55e',
    ringLight: '#dcfce7',
    text: 'text-green-500'
  };
}
export function ScoreRing({
  score,
  max = 10,
  label,
  dynamicColor = false,
  size = 'md'
}: ScoreRingProps) {
  const percentage = score / max * 100;
  const colors = dynamicColor ? getScoreColor(score) : null;
  const sizeClasses = size === 'sm' ? 'w-10 h-10' : 'w-16 h-16';
  const textClass = size === 'sm' ? 'font-serif text-sm font-bold' : 'font-serif text-2xl';
  return <div className="flex flex-col items-center justify-center" data-id="element-386">
      <div className={`relative ${sizeClasses} flex items-center justify-center`} data-id="element-387">
        <svg className="absolute inset-0 w-full h-full transform -rotate-90" viewBox="0 0 36 36" data-id="element-388">
          <path strokeWidth="2" stroke={colors ? colors.ringLight : 'currentColor'} className={colors ? undefined : 'text-crimson-light'} fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" data-id="element-389" />
          <path strokeDasharray={`${percentage}, 100`} strokeWidth="2" strokeLinecap="round" stroke={colors ? colors.ring : 'currentColor'} className={colors ? undefined : 'text-crimson'} fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" data-id="element-390" />
        </svg>
        <span className={`${textClass} ${colors ? colors.text : 'text-crimson'}`} data-id="element-391">
          {score}
        </span>
      </div>
      {label && <span className="mt-2 text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-392">
          {label}
        </span>}
    </div>;
}